import React from 'react';
import PropTypes from 'prop-types';
import {
	Grid,
} from './upsellStyles';
import SingleUpsell from './SingleUpsell';

const Upsells = ({
	upsells,
	currencySymbol,
	currencyCode,
	limit,
}) => {
	if (! upsells.length) return null;
	return (
		<Grid>
			{upsells.slice(0, limit).map(upsell => (
				<SingleUpsell
					key={upsell.id}
					{...upsell}
					currencySymbol={currencySymbol}
					currencyCode={currencyCode}
				/>
			))}
		</Grid>
	);
};

Upsells.propTypes = {
	upsells: PropTypes.array,
	currencySymbol: PropTypes.string,
	currencyCode: PropTypes.string,
	limit: PropTypes.number,
};

Upsells.defaultProps = {
	limit: 3,
	currencyCode: "USD",
	currencySymbol: '$',
};

export default Upsells;
